import Reveal from "@/components/base/Reveal";

export default function StatsSection() {
  return (
    <section
      id="why"
      className="relative w-full bg-[#2563eb] border-t border-white/15 py-28 md:py-40 px-6 md:px-12 overflow-hidden"
    >
      {/* Decorative ornament */}
      <div className="lum-ornament lum-spin-slow hidden md:block" style={{ width: 480, height: 480, top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />

      <div className="max-w-4xl mx-auto relative text-center">
        <Reveal>
          <div className="font-label text-[11px] text-[#93c5fd] mb-10 tracking-[0.4em]">
            RULE / この会のルール
          </div>
        </Reveal>

        <Reveal delay={2}>
          <h3 className="font-jp text-5xl md:text-[52px] lg:text-[68px] leading-[1.3] text-white font-medium mb-10">
            話は、ここに置いて帰る。
          </h3>
        </Reveal>

        <Reveal delay={3}>
          <div className="max-w-xl mx-auto">
            <p className="font-jp text-lg md:text-xl text-white/80 leading-[2.2] mb-6">
              この会で聞いた話は、外には持ち出さない。
            </p>
            <p className="font-jp text-lg md:text-xl text-white/80 leading-[2.2] mb-6">
              ルールと呼べるものは、これひとつだけです。
            </p>
            <p className="font-jp text-lg md:text-xl text-white/80 leading-[2.2]">
              だからここは、素の話をしても大丈夫な場所です。
            </p>
          </div>
        </Reveal>

        <Reveal delay={4}>
          <div className="mt-16 flex items-center justify-center gap-0">
            <div className="h-px w-16 bg-white/40" />
            <div className="w-2 h-2 flex items-center justify-center rounded-full bg-white mx-4" />
            <div className="h-px w-16 bg-white/40" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}